// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ThemeProvider>
  </Router>
);

reportWebVitals();

// Service Worker Registration & Automatic Update Logic
if ('serviceWorker' in navigator) {
  let refreshing = false;
  const hasController = !!navigator.serviceWorker.controller;

  // Automatically reload the page when a new service worker takes over control
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing && hasController) {
      refreshing = true;
      console.log('[Service Worker] New version active. Reloading to update...');
      window.location.reload();
    }
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', { 
      scope: '/',
      updateViaCache: 'none'
    })
      .then((reg) => {
        console.log('[Service Worker] Registered successfully:', reg);

        // If a new worker is waiting, tell it to skip waiting immediately
        if (reg.waiting) {
          reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        }

        // Check for updates immediately on load
        reg.update().catch(() => {});

        // Check for updates every 5 minutes
        setInterval(() => {
          reg.update().catch(() => {});
        }, 5 * 60 * 1000);

        // Check for updates when the tab gains focus
        window.addEventListener('focus', () => {
          reg.update().catch(() => {});
        });

        reg.onupdatefound = () => {
          const installingWorker = reg.installing;
          if (installingWorker) {
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  console.log('[Service Worker] New version installed. Skipping waiting...');
                  installingWorker.postMessage({ type: 'SKIP_WAITING' });
                }
              }
            };
          }
        };
      })
      .catch((err) => {
        console.error('[Service Worker] Registration failed:', err);
      });
  });
}